import React from "react";
import { IconToggle } from "@evergis/ui";
import { useRasterToggle } from "../../hooks/useRasterToggle";
import { FeatureDcExtended } from "../../../../ducks/selectFeatures/types";

export const ToggleRastersIcon = ({ feature }: { feature: FeatureDcExtended }) => {
  const [visible, toggleVisible] = useRasterToggle(feature);

  return (
    <IconToggle isSelected={visible} onClick={toggleVisible} kind={visible ? "raster_visible" : "raster_invisible"} />
  );
};
